<template>
  <div class="payment-simple">
    <span class="text-danger small error-msg">{{ errorMessage }}</span>
    <StripeElements
      :stripe-key="stripeKey"
      :instance-options="instanceOptions"
      :elements-options="elementsOptions"
      #default="{ elements }"
      ref="elms"
    >
      <StripeElement
        class="stripe-element"
        :class="{ complete }"
        @change="complete = $event.complete"
        type="card"
        :elements="elements"
        :options="cardOptions"
        ref="card"
      />
    </StripeElements>
    <button
      class="btn btn-primary"
      @click="pay"
      type="button"
      :disabled="!complete"
    >
      {{ $t("subscription.subscribe") }}
    </button>
  </div>
</template>

<script>
import {
  StripeElements,
  StripeElement,
  createPaymentMethod,
} from "vue-stripe-elements-plus";

export default {
  name: "PaymentSimple",

  components: {
    StripeElements,
    StripeElement,
  },

  data() {
    return {
      stripeKey:
        "pk_test_51Jr1eALwD4JTIsAv0PZFSoIScykT7EM2sW5yucfntBfC3hgPsTLgHvZ5dTjIwCI8akm0jLZwfteSvZCevbEVjvan00I0KQ0jyu", // test key, don't hardcode
      complete: false,
      instanceOptions: {
        // https://stripe.com/docs/js/initializing#init_stripe_js-options
      },
      elementsOptions: {
        // https://stripe.com/docs/js/elements_object/create#stripe_elements-options
      },
      cardOptions: {
        // reactive
        // remember about Vue 2 reactivity limitations when dealing with options
        value: {
          postalCode: "",
        },
        // https://stripe.com/docs/stripe.js#element-options
      },
      errorMessage: null,
    };
  },

  methods: {
    pay2() {
      this.errorMessage = null;
      // ref in template
      const groupComponent = this.$refs.elms;
      const cardComponent = this.$refs.card;
      // Get stripe element
      const cardElement = cardComponent.stripeElement;

      // Access instance methods, e.g. createToken()
      groupComponent.instance
        .createToken(cardElement)
        .then((result) => {
          console.log(result);

          groupComponent.instance
            .createPaymentMethod("card", {
              card: { token: result.token.id },
            })
            .then((result) => {
              console.log(result);
              if (result.error) {
                if (result.error.code == "parameter_missing") {
                  this.errorMessage =
                    "An error occured from our side. please please contact us at contact@icrobotics.com";
                } else
                  this.errorMessage =
                    "An error occured please try again. If the problem persists please contact us at contact@icrobotics.com";
              } else {
                const cardId = result.paymentMethod.id;
                this.$emit("generated-token", cardId);
              }
            });
          // Handle result.error or result.token
        })
        .catch((e) => {
          console.log(e);
        });
    },
    pay() {
      this.errorMessage = null;
      // ref in template
      const groupComponent = this.$refs.elms;
      const cardComponent = this.$refs.card;
      // Get stripe element
      const cardElement = cardComponent.stripeElement;

      groupComponent.instance
        .createPaymentMethod("card", cardElement)
        .then((result) => {
          console.log(result);
          if (result.error) {
            if (result.error.code == "parameter_missing") {
              this.errorMessage =
                "An error occured from our side. please please contact us at contact@icrobotics.com";
            } else
              this.errorMessage =
                "An error occured please try again. If the problem persists please contact us at contact@icrobotics.com";
          } else {
            const cardId = result.paymentMethod.id;
            this.$emit("generated-token", cardId);
          }
        });
    },
  },
};
</script>
<style lang="less">
.payment-simple {
  position: relative;
  .error-msg {
    position: absolute;
    top: -18px;
    line-height: 100%;
  }
}
.stripe-element {
  width: 300px;
  margin-bottom: 12px;
  border: none;
  border-bottom: 1px solid #ccc;
  padding: 10px 0;
  cursor: text;
  color: #495057;
  font-weight: 500;
  background-color: inherit;
}

.stripe-element:focus-within {
  outline: 0;
  border: none;
  border-bottom: 1px solid #666;
  border-color: #495057;
  color: #495057;
}
.stripe-element.complete {
  border-bottom: 1px solid #28a745;
}
</style>